import React from 'react';
import './Team.css';
import ashu from '../../assets/images/ashu-img.png';
import anindya from '../../assets/images/anidya-img.png';
import atul from '../../assets/images/atul-cropped.png';

const leadership = [
  {
    name: 'Ashutosh Tiwari, PhD',
    role: 'Co-Founder & Chief Executive Officer',
    img: ashu,
    bio:
      "Immuno-oncology scientist and biotech entrepreneur with over 15 years of experience advancing antibody-based therapeutics from discovery to translational development. Dr. Tiwari has led cross-functional research programs across antibody engineering and cell-based immunotherapy, with experience spanning academia and emerging biotech ventures. As CEO, he leads Styx’s scientific vision, platform strategy, and execution roadmap to advance differentiated ADC programs toward clinical milestones.",
  },
  {
    name: 'Anindya Bagchi, PhD',
    role: 'Co-Founder & Board Member',
    img: anindya,
    bio:
      "Internationally recognized researcher and scientific leader with extensive experience in oncology drug discovery and company building. Dr. Bagchi is a co-founder of B-Mogen Biotechnologies, which was successfully acquired by Proteintech, and brings deep expertise in translational science and strategic development of therapeutic platforms.",
  },
  {
    name: 'Atul K Tandon, PhD',
    role: 'Board Member & Business Advisor',
    img: atul,
    bio:
      "Seasoned biotech entrepreneur and industry leader with over 40 years of experience in antibody-based therapeutics and diagnostics. A serial entrepreneur, Dr. Tandon has successfully built and exited two life sciences companies. He brings extensive experience in company formation, strategic partnerships, and growth strategy, providing seasoned guidance to Styx’s long-term development and value creation efforts.",
  },
];

export default function Team() {
  return (
    <section id="team" className="team-section" aria-labelledby="team-heading">
      <h2 id="team-heading" className="team-heading">Team</h2>
      <p className="team-sub">
        Styx is led by a team with extensive experience spanning antibody discovery, immuno-oncology, translational research,
        and early clinical development.
      </p>

      <div className="team-lead" aria-label="Leadership">
        <h3 className="lead-title">Leadership</h3>
        <p className="lead-sub">Our leadership combines scientific depth with operational execution and company-building experience.</p>
        <div className="lead-grid" role="list">
          {leadership.map((member) => (
            <article className="lead-card" key={member.name} role="listitem">
              <div className="lead-photo">
                <img src={member.img} alt={member.name} />
              </div>
              <div className="lead-body">
                <h4>{member.name}</h4>
                <div className="role">{member.role}</div>
                <p>{member.bio}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
      
      <div className="advisor-section" aria-label="Scientific Advisors and Collaborators">
        <h3 className="lead-title" style={{ marginTop: 0 }}>Scientific Advisors and Collaborators</h3>
        <p className="lead-sub">Styx is supported by leading clinicians and researchers across oncology, neuro-oncology, cancer biology, and translational medicine.</p>
        <div className="advisor-grid">
          <article className="lead-card" role="article">
            <div className="lead-photo">
              <img src={require('../../assets/images/michael-img.png')} alt="Michael Taylor" />
            </div>
            <div className="lead-body">
              <h4>Michael Taylor, MD, PhD</h4>
              <div className="role">Director, Pediatric Neuro-Oncology, Baylor College of Medicine</div>
              <p>Expert in pediatric neuro-oncology with leadership in clinical translational research and patient-focused care.</p>
            </div>
          </article>

          <article className="lead-card" role="article">
            <div className="lead-photo">
              <img src={require('../../assets/images/david-img.jpg')} alt="David Largaespada" />
            </div>
            <div className="lead-body">
              <h4>David Largaespada, PhD</h4>
              <div className="role">Professor, Masonic Cancer Center, University of Minnesota</div>
              <p>Leader in cancer biology and translational research, co-founder of Luminary Tx with deep preclinical expertise.</p>
            </div>
          </article>

          <article className="lead-card" role="article">
            <div className="lead-photo">
              <img src={require('../../assets/images/jianhua-img.png')} alt="Jianhua Zhao" />
            </div>
            <div className="lead-body">
              <h4>Jianhua Zhao, PhD</h4>
              <div className="role">Asst. Professor, SBP Medical Discovery Institute</div>
              <p>Researcher focused on translational cancer biology and technology development to enable therapeutic innovation.</p>
            </div>
          </article>

          <article className="lead-card" role="article">
            <div className="lead-photo">
              <img src={require('../../assets/images/badri-img.png')} alt="Badrinath Konety" />
            </div>
            <div className="lead-body">
              <h4>Badrinath Konety, MD</h4>
              <div className="role">Professor & President, Allina Health Cancer Institute</div>
              <p>Clinician-scientist with extensive experience in oncology care delivery and translational medicine leadership.</p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}

